import React from "react";

//Components
import { Button, Switch } from "@material-ui/core";
import { Errors, Form, Control } from "react-redux-form";
import { withStyles } from "@material-ui/core/styles";

//Deps
import { errorMessages, validate } from "./../util";

//Styles
const styles = theme => ({
  root: {},
  button: {
    padding: "1em"
  },
  error: {}
});

const SignUpForm = ({ ...props }) => {
  const {
    advancedSignUp,
    handleSubmit,
    handleToggle,
    model,
    //MUI,
    classes,
    //Form Values
    dbErrors,
    email,
    name,
    password,
    passwordConfirm,
    //Form Status
    formIsValid,
    pending
  } = props;

  return (
    <Form
      model={`${model}`}
      onSubmit={val => handleSubmit(val)}
      validators={validate.signUpFormRules(
        email,
        password,
        passwordConfirm,
        dbErrors
      )}>
      <div className="group">
        <Control.text
          model={`${model}.name`}
          type="text"
          validators={validate.nameRules(name)}
          required
        />
        <span className="highlight" />
        <span className="bar" />
        <label>name</label>
      </div>
      <Errors
        model="forms.signUp.name"
        messages={errorMessages.name}
        className={classes.error}
      />

      <div className="group">
        <Control.text
          model={`${model}.email`}
          type="email"
          validators={validate.emailRules(email)}
          required
        />
        <span className="highlight" />
        <span className="bar" />
        <label>email</label>
      </div>
      <Errors
        model="forms.signUp.email"
        messages={errorMessages.email}
        show={{ touched: true, focus: false }}
        className={classes.error}
      />

      <div className="group">
        <Control.text
          model={`${model}.password`}
          type="password"
          validators={validate.passwordRules(password, email)}
          required
        />
        <span className="highlight" />
        <span className="bar" />
        <label>password</label>
      </div>
      <Errors
        model="forms.signUp.password"
        messages={errorMessages.password}
        show={{ touched: true, focus: false }}
        className={classes.error}
      />

      <div className="group">
        <Control.text
          model={`${model}.passwordConfirm`}
          type="password"
          validators={validate.passwordConfirmRules(password, passwordConfirm)}
          required
        />
        <span className="highlight" />
        <span className="bar" />
        <label>confirm password</label>
      </div>
      <Errors
        model="forms.signUp.passwordConfirm"
        messages={errorMessages.passwordConfirm}
        show={{ touched: true, focus: false }}
        className={classes.error}
      />

      <div style={{ paddingBottom: "2em" }}>
        <Switch
          checked={advancedSignUp}
          onChange={handleToggle}
          aria-label="LoginSwitch"
        />
        advanced
      </div>
      {advancedSignUp ? (
        <div>
          <div className="group">
            <Control.text model={`${model}.siteId`} type="text" />
            <span className="highlight" />
            <span className="bar" />
            <label>site id</label>
          </div>
          <div className="group">
            <Control.text model={`${model}.apiKey`} type="text" />
            <span className="highlight" />
            <span className="bar" />
            <label>api key</label>
          </div>
          <div className="group">
            <Control.text model={`${model}.clientKey`} type="text" />
            <span className="highlight" />
            <span className="bar" />
            <label>client key</label>
          </div>
        </div>
      ) : null}
      <Button
        type="submit"
        variant="raised"
        color="primary"
        fullWidth={true}
        disabled={!formIsValid || pending}
        className={classes.button}>
        submit
      </Button>
    </Form>
  );
};

export default withStyles(styles)(SignUpForm);



// WEBPACK FOOTER //
// ./src/components/SignUpForm.js